export enum SupportedDocumentType {
  PDF = 'pdf',
}

export const DocumentContentMap = {
  [SupportedDocumentType.PDF]: 'application/pdf',
};
